import lazyLoading from "./lazyLoading";

export default {
  name: "download",
  meta: {
    expanded: false,
    title: "Excel Downloads",
    class: "primary",
    show: false,
    iconClass: "fa fa-file-excel-o"
  },

  children: [
    {
      name: "download-dbpatients",
      path: "/download/dbpatients",
      component: lazyLoading("download/dbpatients/dbpatients"),
      meta: {
        title: "Baza pacijenata",
        requiredAuth: true
      }
    },
    {
      name: "download-dbracuni",
      path: "/download/dbracuni",
      component: lazyLoading("download/dbracuni/dbracuni"),
      meta: {
        title: "Baza predračuna",
        requiredAuth: true
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/download.js